module.exports = ".links-color {\n  color: #959595; }\n"